import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Eye } from "lucide-react";
import Helpers from "../Helper/Helpers";
import toast from "react-hot-toast";
import { useAuth } from "../context/AuthContextAdmin";
import Lottie from "react-lottie";
import GuyWithBookLottie from "../Assets/Icons/guy_with_book.json";
export const CategoryWiseProduct = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const { fetchProducts } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (location?.state) {
      setProducts(location?.state);
    }
  }, [location]);

  let guyWithBookObj = {
    loop: true,
    autoplay: true,
    animationData: GuyWithBookLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 6;

  const lastProductIndex = currentPage * productsPerPage;
  const firstProductIndex = lastProductIndex - productsPerPage;
  const currentProducts = products.slice(firstProductIndex, lastProductIndex);
  const totalPages = Math.ceil(products.length / productsPerPage);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const HandleAddTocart = async (productId) => {
    if (productId) {
      const res = await Helpers(
        `/admin/product/${productId}/toggle-cart`,
        "PUT"
      );
      if (res && res?.status) {
        toast.success(res?.message);

        // Update product list state locally
        setProducts((prevProducts) =>
          prevProducts.map((product) =>
            product._id === productId
              ? { ...product, addtocartvalue: !product.addtocartvalue }
              : product
          )
        );
        fetchProducts();
      } else {
        toast.error("Failed to update cart status");
      }
    }
  };

  return (
    <>
      {currentProducts?.length > 0 ? (
        <section className="bestsellers">
          <h2 className="testimonials-heading">
            <span style={{ color: "red" }}>Explore </span>
            <span className="dark-red">Products by </span>
            <span className="orange">{currentProducts[0]?.category?.name}</span>
          </h2>
          <p>
            Check out our most popular products this week! Our customers love
            these items for their quality and price. Hurry, they're selling
            fast!
          </p>

          <div className="container mx-auto px-4 py-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {currentProducts.map((product, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="relative">
                    {/* SALE Badge */}
                    <div className="absolute top-3 left-3 z-10">
                      <span className="bg-[#2F4858] text-white text-xs font-semibold px-2 py-1 rounded">
                        SALE
                      </span>
                    </div>

                    {/* Eye Icon */}
                    <div
                      className="absolute top-3 right-3 z-10"
                      onClick={() =>
                        navigate("/singlepage", { state: product })
                      }
                    >
                      <button className="bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors">
                        <Eye
                          style={{ color: "#dc0000" }}
                          className="w-4 h-4 text-gray-600"
                        />
                      </button>
                    </div>

                    {/* Product Image */}
                    <div
                      className="relative h-[300px]"
                      onClick={() =>
                        navigate("/singlepage", { state: product })
                      }
                    >
                      <img
                        src={product.images?.[0]}
                        alt={product.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>

                  <div className="p-5">
                    <div className="mb-4">
                      <span className="text-sm text-gray-500 mb-2 block">
                        {product?.category?.name}
                      </span>
                      <h3 className="text-xl font-semibold mb-2">
                        {product.name}
                      </h3>
                    </div>

                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className="text-xl font-bold">
                          ₹{product?.price.toFixed(2)}
                        </span>
                        <span className="text-gray-500 line-through text-sm">
                          ₹{product?.originalPrice?.toFixed(2)}
                        </span>
                      </div>
                      <button
                        onClick={() => HandleAddTocart(product?._id)}
                        style={{
                          backgroundColor: product?.addtocartvalue
                            ? "#b91c1c"
                            : "#1d4ed8",
                        }}
                        className="text-white px-4 py-2 rounded hover:opacity-90 transition-colors text-sm"
                      >
                        {product?.addtocartvalue
                          ? "Remove Item"
                          : "Add to Cart"}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            <div className="flex justify-center items-center mt-6 gap-2">
              <button
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                ←
              </button>
              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i}
                  onClick={() => goToPage(i + 1)}
                  className={`px-3 py-1 border rounded ${
                    currentPage === i + 1 ? "bg-[#dc0000] text-white" : ""
                  }`}
                >
                  {i + 1}
                </button>
              ))}
              <button
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                →
              </button>
            </div>
          </div>
        </section>
      ) : (
        // <div
        //   style={{ textAlign: "center", marginTop: "8rem", padding: "1rem" }}
        // >
        //   No Product Available...
        // </div>
        <div
          className="flex flex-col items-center justify-center text-center py-10"
          style={{ minHeight: "200px" }}
        >
          <Lottie
            options={guyWithBookObj}
            height={220}
            width={220}
            isStopped={false}
            isPaused={false}
          />
          <h2>No Product Available 🙃</h2>
          <Link to="/">
            <button
              type="button"
              style={{
                backgroundColor: "#28a745",
                color: "#fff",
                padding: "12px 24px",
                fontSize: "16px",
                borderRadius: "10px",
                border: "none",
                cursor: "pointer",
                boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
                transition: "all 0.3s ease",
                animation: "bounce 1.5s infinite",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#218838";
                e.target.style.transform = "scale(1.05)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#28a745";
                e.target.style.transform = "scale(1)";
              }}
            >
              🛍️ Let's Shop
            </button>
            <style>
              {`
          @keyframes bounce {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-5px);
            }
          }
        `}
            </style>
          </Link>
        </div>
      )}
    </>
  );
};
